var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"p-1x m-0"},[_c('b-button',{staticClass:"p-1 m-0 border-top-0 border-0 px-2",attrs:{"variant":"outline-light","size":"sm"},on:{"click":_vm.add}},[_c('icon',{attrs:{"name":"mdi.plus-thick"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }